import {forwardRef, useImperativeHandle} from 'react';
import AuthN from '../services/authnApi';
import MySpot from '../services/mySpotApi';

const SaveSpot = forwardRef(({isTablet}, ref)=>{

  useImperativeHandle(ref, () => ({
    savePOISpot: savePOISpot
  }));

  const savePOISpot = ({poi_code=null, name=null, address=null, lat=null, lng=null}) => {
    AuthN.setUrl(process.env.REACT_APP_API_AUTHN_URL);
    AuthN.refreshToken();

    const accessToken = AuthN.getAccessToken();
    if(!accessToken){
      // ログイン済みでない場合はログインページに遷移する
      alert("スポットを保存するには、ログインまたは会員登録が必要です。");
      if(isTablet){
        // SP
        window.location.href = `${process.env.REACT_APP_BASE_URL}/smp/account/login_member/?type=savespot&ref=${window.location.pathname}`
      }else{
        // PC
        window.location.href = `${process.env.REACT_APP_BASE_URL}/account/login/?type=savespot&ref=${window.location.pathname}`;
      }
    }

    let requestData = {
      poi_code,
      name,
      address,
      lat,
      lng
    }
    // 不要なキーを削除する
    Object.keys(requestData).forEach((key)=>{
      if(!requestData[key]){
        delete requestData[key];
      }
    });

    MySpot.post(accessToken, requestData, ({result})=>{
      if(result === 201){
        alert("スポットを登録しました。");
      } else if(result === 400){
        alert("既に登録されています。");
      } else {
        alert("スポットを保存するには、ログインまたは会員登録が必要です。");
      }
    }
   );
  }
  return <></>
});

export default SaveSpot;